import axios from 'axios';
import { postAws } from '../postAws';


import AWS from 'aws-sdk';
const API_URL = "https://api-dev.aurait.ai";


const region = "ap-south-1";
const service = 'execute-api';

const credentials = new AWS.Credentials({
  accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
  secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY
});

async function getAws(api) {
  try {
    const signRequest = async (url) => {
      const endpoint = new URL(url);
      const request = new AWS.HttpRequest(endpoint, region);
      request.method = 'GET';
      request.path = endpoint.pathname + endpoint.search; 
      request.headers['Host'] = endpoint.host;
      request.headers['Content-Type'] = 'application/json';
  
      const signer = new AWS.Signers.V4(request, service);
      signer.addAuthorization(credentials, new Date());
      
      return request.headers;
    };
  
    const signedHeaders = await signRequest(api);

    const response = await axios({
      method: 'get',
      url: api,
      headers: signedHeaders,
    });

    console.log('Success:', response.data);
    return response.data;

  } catch (error) {
    console.error('Error in getAws:', error);
    throw error; // Re-throw the error so the calling function can handle it
  }
}

export const getAllNotification = async (userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/alert?id=${userId}`))
  return response;
} 

export const getAllnotes = async (classRoomId, userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/notes/allNotes?classRoomId=${classRoomId}&userId=${userId}`))
  return response;
}

export const getAllbooks = async (classRoomId) => {
  const response = await getAws((`https://api-dev.aurait.ai/library/allBooks?id=${classRoomId}`))
  return response;
}

export const getbook = async (bookId) => {
  const response = await getAws((`https://api-dev.aurait.ai/library?id=${bookId}`))
  return response.body;
}

export const getCourseDetials = async (courseId) => {
  try {
    console.log("Calling getCourseDetials with courseId:", courseId)
    const url = `https://api-dev.aurait.ai/eLearning?courseId=${courseId}`
    console.log("API URL:", url)

    const response = await getAws(url)
    console.log("Raw API response:", response)

    if (!response || !response.body) {
      throw new Error("Invalid response from API")
    }

    return response.body
  } catch (error) {
    console.error("Error in getCourseDetials:", error)
    throw error
  }
}

export const getAllSubmisions = async (assignmentId) => {
  const response = await getAws((`https://api-dev.aurait.ai/submission/assignment?id=${assignmentId}`))
  return response.body;
}

export const getAllQuizSubmissions = async (assignmentId) => {
  const response = await getAws((`https://api-dev.aurait.ai/quizSubmission/quiz?id=${assignmentId}`))
  return response.body;
}

export const getEvaluatedAssignmentAndQuiz = async (studentId,classRoomId) => {
  const response = await getAws((`https://api-dev.aurait.ai/evaluatedAssignmentAndQuiz?studentId=${studentId}&classRoomId=${classRoomId}`))
  return response;
}


export const getMessages = async (gid, before = null, limit = 100) => {
  let url = `https://api-dev.aurait.ai/chat/messages?id=${gid}&limit=${limit}`;
  
  // Add the 'before' parameter if provided
  if (before) {
    url += `&before=${before}`;
  }
  
  const response = await getAws(url);
  return response.body;
}


export const getConversation = async (userId) => {
  const response = await getAws((`https://api-dev.aurait.ai/chat?id=${userId}`))
  return response.body;
}

export const getContacts = async (userId) => {
  try {
    const response = await getAws(`https://api-dev.aurait.ai/chat/contacts/teacherContacts?id=${userId}`)
    
    // If response.body is a string, parse it
    if (typeof response.body === 'string') {
      try {
        return JSON.parse(response.body)
      } catch (e) {
        console.error("Error parsing response body:", e)
        return []
      }
    }
    
    // If it's already an object, return it
    return response.body || []
  } catch (error) {
    console.error("Error in getContacts:", error)
    return []
  }
}

export const getAllAssigmentData=async (classRoomId) => {
  const response=await getAws((`https://api-dev.aurait.ai/assignment/classRoom?id=${classRoomId}`));
  return response.body;

}

export const getAllQuizData = async (classRoomId) => {
  try {
    const response = await getAws(`https://api-dev.aurait.ai/quiz/ClassRoom?id=${classRoomId}`)
    if (response.statusCode === 200 && response.body) {
      return response
    } else {
      throw new Error("Invalid response from API")
    }
  } catch (error) {
    console.error("Error fetching quiz data:", error)
    throw error
  }
}

export const getAnnouncements = async (classRoomId) => {
  const response = await getAws((`https://api-dev.aurait.ai/announcement?id=${classRoomId}`))
  return response.body.data;
}

export const getAssignmentData=async(assignmentId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/assignment?id=${assignmentId}`)
  console.log("response is",response);
  return response;
}

export const getQuizData=async(QuizId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/quiz?id=${QuizId}`)
  console.log("response is",response);
  return response;
}


export const getExamData=async(assignmentId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/exam?id=${assignmentId}`)
  console.log("response is",response);
  return response;
  

}


export const getSubmissionDetials=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/submission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}


export const getQuizSubmissionDetail=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/quizSubmission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}

export const getExamSubmissionDetails=async(submssionId)=>{
  const response =await getAws(`https://api-dev.aurait.ai/examSubmission?id=${submssionId}`)
  console.log("response for submission is",response);

  return response;
}



export const evaluateAnswers=async(assignmentQuestion)=>{
  const response=await postAws(`https://api-dev.aurait.ai/evaluate`,"POST",assignmentQuestion)
  return response;
}

export const getClassData= async (classId) => {
 
    const response= await getAws(`https://api-dev.aurait.ai/classroom?id=${classId}`);
    return response;

}


export const getClassCode = async (teacherId, className) => {
  try {
    const response = await axios.get(`${API_URL}/class-code`, {
      params: { teacherId, className }
    });
    return response.data.classCode;
  } catch (error) {
    console.error('Error fetching class code:', error);
    throw error;
  }
};



export const updateExam = async (examData) => {
  try {
    const response = await axios.put(`${API_URL}/exam/update-exam`, examData);
    return response.data;
  } catch (error) {
    console.error('Error updating exam:', error);
    throw error;
  }
};

export const getExamById = async (examId) => {
  try {
    const response = await axios.get(`${API_URL}/exam/exam/${examId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching exam:', error);
    throw error;
  }
};

export const extractTextFromPDF = async (file, assignmentName) => {
  const formData = new FormData();
  formData.append('pdfFile', file);

  try {
    const response = await axios.post(`${API_URL}/extract?assignmentName=${assignmentName}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    console.log('API Response:', response.data);

    if (!response.data || typeof response.data !== 'object') {
      throw new Error('Invalid response format from server');
    }

    return response.data;
  } catch (error) {
    console.error('Error extracting text:', error);
    throw error;
  }
};

export const getTeacherData = async () => {
  try {
    const token = localStorage.getItem('token');
    const teacherid = localStorage.getItem('teacherId');
    if (!token) {
      throw new Error('No token found');
    }
    console.log('Fetching teacher data...');
    const response = await getAws(`https://api-dev.aurait.ai/teacher?id=${teacherid}`)
    

   
    console.log('Teacher data fetched successfully:', response);
    return response;
   
  } catch (error) {
    console.error('Error in getTeacherData:', error);
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response data:', error.response);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error setting up request:', error.message);
    }
    throw error;
  }
};


export const logoutTeacher = () => {
  localStorage.clear()
};

export const loginTeacher = async (identifier, password) => {
  const loginData = {
    body: {
      teacherEmail: identifier,
      password: password
    },
    request: "login-Teacher"
  }
  try {
    const response = await postAws("https://api-dev.aurait.ai/auth/teacher-auth", "POST", loginData);
    console.log('Login response:', response);

    if (response && response.token && response.teacherId) {
      localStorage.setItem('token', response.token);
      localStorage.setItem('teacherId', response.teacherId);
      console.log('Token and teacherId stored in localStorage');
      return response;
    } else if (response && response.statusCode) {
      // Handle different status codes
      switch (response.statusCode) {
        case 400:
          throw new Error(response.body?.error || 'Incorrect Password');
        case 401:
          throw new Error(response.message || 'Invalid credentials');
        case 404:
          throw new Error(response.message || 'Teacher not found');
        default:
          throw new Error(response.message || 'An error occurred during login');
      }
    } else {
      console.error('Invalid response from server:', response);
      throw new Error('Invalid response from server');
    }
  } catch (error) {
    console.error('Login error:', error);
    throw error; // Throw the error object directly
  }
};







export const getToken = () => {
  return localStorage.getItem('token');
};

export const extractRawTextFromPDF = async (file) => {
  const formData = new FormData();
  formData.append('pdfFile', file);

  try {
    const response = await axios.post(`${API_URL}/justextract`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (!response.data || !response.data.extractedText) {
      throw new Error('No text extracted or invalid response format');
    }

    return response.data;
  } catch (error) {
    console.error('Error extracting text from PDF:', error);
    throw new Error('Failed to extract text from PDF');
  }
};

export const generateQuestionsWithAI = async (params) => {
  try {
    const response = await postAws("https://api-dev.aurait.ai/assignment/schedule", "POST", params);

    // Log the raw response for debugging
    console.log('Raw API Response:', response);

    if (!response || !response.body) {
      throw new Error('No response data received');
    }

    let parsedBody;
    try {
      parsedBody = JSON.parse(response.body);
    } catch (parseError) {
      console.error('Error parsing response body:', parseError);
      throw new Error('Invalid response format');
    }

    if (parsedBody.message === "Invocation successful" && parsedBody.result.StatusCode === 202) {
      console.log('Assignment creation scheduled successfully');
      return {
        success: true,
        message: 'Assignment creation scheduled successfully'
      };
    } else {
      throw new Error('Unexpected response format');
    }
  } catch (error) {
    console.error('Error generating questions:', error);
    return {
      success: false,
      error: error.message || 'Failed to generate questions'
    };
  }
};

export const generateQuizWithAi = async (params) => {
  try {
    const response = await postAws("https://api-dev.aurait.ai/quiz", "POST", params);

    // Log the raw response for debugging
    console.log('Raw API Response:', response);

    if (!response || !response.body) {
      throw new Error('No response data received');
    }

    let parsedBody;
    try {
      parsedBody = JSON.parse(response.body);
    } catch (parseError) {
      console.error('Error parsing response body:', parseError);
      throw new Error('Invalid response format');
    }

    if (parsedBody.message === "Invocation successful" && parsedBody.result.StatusCode === 202) {
      console.log('Assignment creation scheduled successfully');
      return {
        success: true,
        message: 'Assignment creation scheduled successfully'
      };
    } else {
      throw new Error('Unexpected response format');
    }
  } catch (error) {
    console.error('Error generating questions:', error);
    return {
      success: false,
      error: error.message || 'Failed to generate questions'
    };
  }
};

export const createS3FolderStructure = async (assignment) => {
  try {
    const response = await axios.post(`${API_URL}/create-folder-structure`, { assignment });
    return response.data;
  } catch (error) {
    console.error('Error creating S3 folder structure:', error);
    throw error;
  }
};

export const uploadFileToS3 = async (file, title) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', title);

  try {
    const response = await axios.post(`${API_URL}/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.fileUrl;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const updateAssignment = async (updatedAssignment) => {
  try {
    const response = await fetch(`${API_URL}/update-assignment`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedAssignment),
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Assignment updated:', data);
    } else {
      const errorData = await response.json();
      console.error('Error updating assignment:', errorData);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const signupTeacher = async (teacherData) => {
  try {
    const response = await axios.post(`${API_URL}/auth/signupTeacher`, teacherData);
    return response.data;
  } catch (error) {
    console.error('Error signing up teacher:', error);
    throw error;
  }
};
export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${API_URL}/auth/verify-otp/Teacher`, { email, otp });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};









export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/auth/forgot-password/Teacher`, { email });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error || 'An error occurred while processing your request');
    } else if (error.request) {
      throw new Error('No response received from server');
    } else {
      throw new Error('Error setting up the request');
    }
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(`${API_URL}/auth/reset-password/Teacher`, { token, newPassword });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.error || 'An error occurred while resetting your password');
    } else if (error.request) {
      throw new Error('No response received from server');
    } else {
      throw new Error('Error setting up the request');
    }
  }
};




export const addStudentToClass = async (teacherId, studentEmail, studentName, classCode, subject) => {
  try {
    const response = await axios.post(`${API_URL}/teacher/add-student`, {
      teacherId,
      studentEmail,
      studentName,
      classCode,
      subject
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error adding student to class');
  }
};

export const getStudentsByClassAndSubject = async (teacherId, classCode, subject) => {
  try {
    const response = await axios.get(`${API_URL}/teacher/students`, {
      params: { teacherId, classCode, subject }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error fetching students');
  }
};


export const requestToJoinClass = async (studentId, classCode, subject) => {
  try {
    const response = await axios.post(`${API_URL}/students/request-join`, { studentId, classCode, subject });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Error sending join request');
  }
};






export const getStudentRequests = async (classCode, subject) => {
  try {
    console.log('Fetching student requests with params:', { classCode, subject });
    const response = await axios.get(`${API_URL}/auth/teacher/student-requests`, {
      params: { classCode, subject }
    });
    console.log('Student requests response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching student requests:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const approveStudent = async (studentId, classCode, subject) => {
  try {
    const response = await axios.post(`${API_URL}/auth/teacher/approve-student`, {
      studentId,
      classCode,
      subject
    });
    return response.data;
  } catch (error) {
    console.error('Error approving student:', error);
    throw error;
  }
};

export const declineStudent = async (studentId, classCode, subject) => {
  try {
    const response = await axios.post(`${API_URL}/auth/teacher/decline-student`, {
      studentId,
      classCode,
      subject
    });
    return response.data;
  } catch (error) {
    console.error('Error declining student request:', error);
    throw error;
  }
};



export const getEnrolledStudents = async (classCode, subject) => {
  try {
    console.log('Fetching enrolled students with params:', { classCode, subject });
    const response = await axios.get(`${API_URL}/auth/teacher/students`, {
      params: { classCode, subject }
    });
    console.log('Enrolled students response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching enrolled students:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export const createExamWithAI = async (examData) => {
  try {
    const response = await postAws("https://api-dev.aurait.ai/exam/create-exam-with-ai", "POST", examData);

    if (!response || !response.body) {
      throw new Error('No response data received');
    }

    console.log('Raw API Response:', response.body);

    let parsedBody;
    try {
      parsedBody = JSON.parse(response.body);
    } catch (parseError) {
      console.error('Error parsing response body:', parseError);
      throw new Error('Invalid response format from server');
    }

    if (!parsedBody.questionArray || !Array.isArray(parsedBody.questionArray)) {
      throw new Error('Invalid question array in response');
    }

    return parsedBody;
  } catch (error) {
    console.error('Error creating exam with AI:', error);
    if (error.response?.data) {
      console.error('Server Error Details:', error.response.data);
      throw new Error(
        error.response.data.error ||
        error.response.data.details ||
        'Server error occurred'
      );
    } else if (error.request) {
      throw new Error('No response received from server');
    } else {
      throw new Error(error.message || 'Failed to send request');
    }
  }

};



export const evaluateExamThroughAI = async (examSubmission) => {
  try {
    const questionsForEvaluation = examSubmission.examQuestion.flatMap(section => 
      section.questions.map(question => ({
        id: question._id,
        text: question.text,
        type: question.type,
        marks: question.marks,
        user_answer: question.user_answer,
        user_image: question.image
      }))
    );

    const aiExamEval = await postAws('https://api-dev.aurait.ai/exam/evaluate-ai', "POST", questionsForEvaluation);
    const aiExamEvalObj = JSON.parse(aiExamEval.body);

    const updatedExamQuestion = examSubmission.examQuestion.map(section => ({
      ...section,
      questions: section.questions.map(question => {
        const aiEvaluation = aiExamEvalObj.data.find(q => q.id === question._id);
        return {
          ...question,
          remarks: aiEvaluation ? aiEvaluation.remarks : '',
          givenMarks: aiEvaluation ? aiEvaluation.givenMarks : 0
        };
      })
    }));

    const totalObtainedMarks = updatedExamQuestion.reduce((total, section) => 
      total + section.questions.reduce((sectionTotal, question) => 
        sectionTotal + (question.givenMarks || 0), 0
      ), 0
    );

    const evaluatedSubmission = {
      ...examSubmission,
      examQuestion: updatedExamQuestion,
      obtainedMarks: totalObtainedMarks,
      status: "evaluated"
    };

    return evaluatedSubmission;
  } catch (error) {
    console.error('Error in AI evaluation:', error);
    throw error;
  }
};

export const shareExamEvaluation = async (submission) => {
  try {
    const submissionData = {
      id: submission._id,
      body: submission,
      request: "evaluate-Exam"
    };
    const response = await postAws(`https://api-dev.aurait.ai/exam/submission`, "POST", submissionData);
    return response;
  } catch (error) {
    console.error('Error sharing exam evaluation:', error);
    throw error;
  }
};

